<pr-form
  (onSubmit)="submit()"
  [title]="isPersonMoral ? 'Profil de risque - Entreprise' : 'Profil de risque'"
  [formGroup]="form"
  clazz="ea-risk-profile-form"
>
  <!-- ================================================================== -->
  <!-- SECTION 1 : PROFIL DE RISQUE -->
  <!-- ================================================================== -->

  <div class="ea-risk-profile-form__section-divider">
    <span class="ea-risk-profile-form__section-title">PROFIL DE RISQUE</span>
  </div>

  <!-- ========== PERSONNE PHYSIQUE FIELDS ========== -->
  @if (!isPersonMoral) {
    <!-- Champ 2 : Situation personnelle -->
    <pr-input-radio
      formControlName="maritalStatus"
      label="Situation personnelle"
      [derrors]="derrors"
      [isDefault]="false"
      [columns]="3"
      [options]="maritalStatusOptions"
    ></pr-input-radio>

    <!-- Champ 3 : Statut d'occupation -->
    <pr-input-radio
      formControlName="occupancyStatus"
      label="Statut d'occupation"
      [derrors]="derrors"
      [isDefault]="false"
      [columns]="3"
      [options]="occupancyStatusOptions"
    ></pr-input-radio>

    <!-- Champ 4 : Crédit -->
    <pr-input-radio
      formControlName="credit"
      label="Avez-vous un crédit ?"
      [derrors]="derrors"
      [isDefault]="false"
      [columns]="3"
      [options]="yesNoOptions"
    ></pr-input-radio>

    <!-- Champ 5 : Encadré informatif crédit -->
    @if (showCreditInfo) {
      <div class="ea-risk-profile-form__info-box">
        <p>
          Vous avez <strong>{{ loanCount }}</strong> crédit(s) en cours.
        </p>
        <p>
          Total restant à rembourser :
          <strong>{{ loanTotal | number: '1.0-2' : 'fr-FR' }} €</strong>
        </p>
      </div>
    }

    <!-- Champ 6 : Travail dans la finance -->
    <pr-input-radio
      formControlName="workInFinance"
      label="Travaillez-vous dans le domaine de la finance ?"
      [derrors]="derrors"
      [isDefault]="false"
      [columns]="3"
      [options]="yesNoOptions"
    ></pr-input-radio>

    <!-- Champ 7 : Presse spécialisée -->
    <pr-input-radio
      formControlName="readSpecializedPress"
      label="Lisez-vous parfois la presse économique ou patrimoniale ?"
      [derrors]="derrors"
      [isDefault]="false"
      [columns]="3"
      [options]="yesNoOptions"
    ></pr-input-radio>
  }

  <!-- ========== PERSONNE MORALE FIELDS ========== -->
  @if (isPersonMoral) {
    <!-- Champ 8 : Structure juridique -->
    <pr-input label="Structure juridique" [derrors]="derrors">
      <mat-select formControlName="legalStructure">
        @for (option of legalStructureOptions; track option.value) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </pr-input>

    <!-- Champ 9 : CA annuel -->
    <pr-input label="CA annuel" [derrors]="derrors">
      <mat-select formControlName="caValue">
        @for (option of caValueOptions; track option.value) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </pr-input>

    <!-- Champ 14 : Valeur patrimoine (pour personne morale) -->
    <pr-input label="Valeur patrimoine" [derrors]="derrors">
      <mat-select formControlName="patrimonyValue">
        @for (option of patrimonyValueOptions; track option.value) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </pr-input>

    <!-- Champ 10 : Date de création -->
    <pr-input label="Date de création" [derrors]="derrors">
      <mat-select formControlName="dateDeCreation">
        @for (option of dateCreationOptions; track option.value) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </pr-input>

    <!-- Champ 11 : Résultat net -->
    <pr-input-radio
      formControlName="resultatNet"
      label="Dégagez-vous un résultat positif net avant impôt ?"
      [derrors]="derrors"
      [isDefault]="false"
      [columns]="3"
      [options]="yesNoOptions"
    ></pr-input-radio>

    <!-- Champ 12 : Leasing -->
    <pr-input-radio
      formControlName="leasing"
      label="Avez-vous un leasing en cours ?"
      [derrors]="derrors"
      [isDefault]="false"
      [columns]="3"
      [options]="yesNoOptions"
    ></pr-input-radio>

    <!-- Champ 13 : Trésorerie à placer -->
    <pr-input-radio
      formControlName="tresorerieAPlacer"
      label="Avez-vous de la trésorerie long terme à placer (> 5 ans) ?"
      [derrors]="derrors"
      [isDefault]="false"
      [columns]="3"
      [options]="yesNoOptions"
    ></pr-input-radio>
  }

  <!-- ========== CHAMPS COMMUNS ========== -->

  <!-- Champ 14 : Valeur patrimoine (pour personne physique uniquement) -->
  @if (!isPersonMoral) {
    <pr-input label="Valeur patrimoine" [derrors]="derrors">
      <mat-select formControlName="patrimonyValue">
        @for (option of patrimonyValueOptions; track option.value) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </pr-input>
  }

  <!-- Champ 15 : Salaire annuel (personne physique uniquement) -->
  @if (!isPersonMoral) {
    <pr-input label="Salaire annuel" [derrors]="derrors">
      <mat-select formControlName="income">
        @for (option of incomeOptions; track option.value) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </pr-input>
  }

  <!-- Champ 16 : Image graphique risque -->
  <div class="ea-risk-profile-form__chart-container">
    <img
      [src]="riskChartImageUrl"
      alt="Graphique de profil de risque"
      class="ea-risk-profile-form__chart-image"
    />
  </div>

  <!-- Champ 17 : Tolérance au risque -->
  <pr-input
    label="Quelle est votre tolérance au risque ?"
    [derrors]="derrors"
    class="ea-risk-profile-form__dropdown-wide"
  >
    <mat-select formControlName="riskTolerance">
      @for (option of riskToleranceOptions; track option.value) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <!-- Champ 18 : Rendement souhaité -->
  <pr-input
    label="Pour un investissement, vous recherchez :"
    [derrors]="derrors"
    class="ea-risk-profile-form__dropdown-wide"
  >
    <mat-select formControlName="desiredYield">
      @for (option of desiredYieldOptions; track option.value) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <!-- Champ 19 : Concept rendement/risque -->
  <pr-input
    label="Que signifie la notion de couple rendement / risque ?"
    [derrors]="derrors"
    class="ea-risk-profile-form__dropdown-wide"
  >
    <mat-select formControlName="conceptReturnRisk">
      @for (option of conceptReturnRiskOptions; track option.value) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <!-- Champ 20 : Capacité à subir des pertes -->
  <pr-input
    label="Quelle est votre capacité à subir des pertes ?"
    [derrors]="derrors"
    class="ea-risk-profile-form__dropdown-wide"
  >
    <mat-select formControlName="lossTolerance">
      @for (option of lossToleranceOptions; track option.value) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <!-- ================================================================== -->
  <!-- SECTION 2 : CONNAISSANCE ET EXPÉRIENCE FINANCIÈRE -->
  <!-- ================================================================== -->

  <div class="ea-risk-profile-form__section-divider">
    <span class="ea-risk-profile-form__section-title"
      >CONNAISSANCE ET EXPÉRIENCE FINANCIÈRE</span
    >
  </div>

  <!-- Champ 21 : Baisse de placement -->
  <pr-input-radio
    formControlName="hadInvestmentDecrease"
    label="Avez-vous connu une baisse de l'un de vos placements ?"
    [derrors]="derrors"
    [isDefault]="false"
    [columns]="3"
    [options]="yesNoOptions"
  ></pr-input-radio>

  <!-- Champ 22 : Réaction face à une baisse -->
  <pr-input
    label="Quelle serait votre réaction face à une baisse de l'un de vos placements ?"
    [derrors]="derrors"
    class="ea-risk-profile-form__dropdown-wide"
  >
    <mat-select formControlName="investmentDecreaseReaction">
      @for (option of investmentDecreaseReactionOptions; track option.value) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <!-- Champ 23 : Question épargne -->
  <pr-input
    label="Vous avez 100 € sur un compte d'épargne rémunéré à 2% par an. Combien aurez-vous dans 5 ans ?"
    [derrors]="derrors"
    class="ea-risk-profile-form__dropdown-wide"
  >
    <mat-select formControlName="savingsRate">
      @for (option of savingsRateOptions; track option.value) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <!-- Champ 24 : Jeux d'argent -->
  <pr-input
    label="Jouez vous à des jeux d'argent (jeux en ligne, paris sportifs, casino...) ?"
    [derrors]="derrors"
    class="ea-risk-profile-form__dropdown-wide"
  >
    <mat-select formControlName="moneyGames">
      @for (option of moneyGamesOptions; track option.value) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <!-- Champ 25 : Connaissances investissement (checkboxes) -->
  <pr-checkbox-group
    formControlName="investmentKnowledge"
    label="Parmi la liste, quels placements connaissez vous ?"
    [derrors]="derrors"
    [options]="investmentKnowledgeOptions"
    [detectChangesOnWrite]="true"
  >
  </pr-checkbox-group>

  <!-- ================================================================== -->
  <!-- SOUS-FORMULAIRES CONDITIONNELS D'INVESTISSEMENT -->
  <!-- ================================================================== -->

  @for (question of getActiveInvestmentQuestions(); track question.type) {
    <div class="ea-risk-profile-form__investment-section">
      <!-- Titre de la section -->
      <h4 class="ea-risk-profile-form__investment-title">
        {{ question.title }}
      </h4>

      <!-- Question de connaissance -->
      <pr-input-radio
        [formControlName]="question.knowledgeField"
        [label]="question.question"
        [derrors]="derrors"
        [isDefault]="false"
        [columns]="3"
        [options]="trueFalseUnknownOptions"
      ></pr-input-radio>

      <!-- Toggle "Avez-vous déjà investi ?" -->
      <pr-input-radio
        [formControlName]="question.investField"
        label="Avez-vous déjà investi ?"
        [derrors]="derrors"
        [isDefault]="false"
        [columns]="3"
        [options]="[
          { value: false, label: 'Non' },
          { value: true, label: 'Oui' },
        ]"
      ></pr-input-radio>

      <!-- Type de gestion (si a investi) -->
      @if (hasInvested(question.investField)) {
        <pr-input label="Type de gestion" [derrors]="derrors">
          <mat-select [formControlName]="question.managementModeField">
            @for (option of managementModeOptions; track option.value) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </pr-input>
      }
    </div>
  }
</pr-form>
